import { render } from "./DinhMucCoDinhSection.vue?vue&type=template&id=0326dc1a&ts=true"
import script from "./DinhMucCoDinhSection.vue?vue&type=script&lang=ts"
export * from "./DinhMucCoDinhSection.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/prod/fe/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__